import React, { Component } from 'react'
import { withI18n } from '@lingui/react'
import values from 'lodash/fp/values'
import flatten from 'lodash/fp/flatten'
import map from 'lodash/fp/map'
import compose from 'lodash/fp/compose'
import join from 'lodash/fp/join'

import JobsLayout from 'client/bookmate/blocks/jobs-layout'
import HeaderBox from 'client/shared/boxes/header-box'

import MetaTitle from 'client/shared/blocks/meta-title'
import { MetaDescription } from 'client/shared/blocks/meta-description'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import jobs from 'client/bookmate/blocks/jobs-layout/jobs'

const extractJobs = compose(join(', '), map('job'), flatten, values)

class JobsPage extends Component<{ i18n: any }> {
  render() {
    const { i18n } = this.props
    const headTitle = i18n.t`jobs.title`
    const jobTitles = extractJobs(jobs)
    const description = i18n._('jobs.meta_description', { jobs: jobTitles })
    return (
      <>
        <MetaTitle title={headTitle} />
        <MetaDescription description={description} />
        <HeaderBox />
        <JobsLayout />
      </>
    )
  }
}

export default withI18n({ update: true })(JobsPage)
